(() => {
  function initEventBuy() {
    const root = document.getElementById('eventBuy');
    if (!root) return;

    const items = [...root.querySelectorAll('.event-buy__item')];
    const totalEl = document.getElementById('eventTotal');
    const checkoutBtn = document.getElementById('eventCheckoutBtn');
    const errorEl = document.getElementById('eventBuyError');
    const eventTag = root.dataset.eventTag || '';

    function formatMoney(cents) {
      const amount = (cents / 100).toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return `$${amount}`;
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    function getQty(item) {
      const output = item.querySelector('.event-buy__item-qty-value');
      return output ? Number(output.textContent) || 0 : 0;
    }

    function setQty(item, qty) {
      const output = item.querySelector('.event-buy__item-qty-value');
      if (output) output.textContent = String(qty);
    }

    function updateTotal() {
      let total = 0;
      let hasSelection = false;

      items.forEach((item) => {
        const qty = getQty(item);
        if (qty > 0) {
          hasSelection = true;
          total += Number(item.dataset.price || 0) * qty;
        }
      });

      if (totalEl) totalEl.textContent = formatMoney(total);
      if (checkoutBtn) checkoutBtn.disabled = !hasSelection;
    }

    items.forEach((item) => {
      const minusBtn = item.querySelector('.event-buy__item-qty-btn[data-step="-1"]');
      const plusBtn = item.querySelector('.event-buy__item-qty-btn[data-step="1"]');

      minusBtn?.addEventListener('click', () => {
        const qty = Math.max(0, getQty(item) - 1);
        setQty(item, qty);
        updateTotal();
      });

      plusBtn?.addEventListener('click', () => {
        const qty = Math.min(50, getQty(item) + 1);
        setQty(item, qty);
        updateTotal();
      });
    });

    checkoutBtn?.addEventListener('click', async () => {
      const selected = items
        .map((item) => ({ id: Number(item.dataset.variantId), quantity: getQty(item) }))
        .filter((line) => line.id && line.quantity > 0);

      if (checkoutBtn.disabled || !selected.length) return;

      clearError();
      checkoutBtn.disabled = true;
      const original = checkoutBtn.textContent;
      checkoutBtn.textContent = 'Agregando…';

      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: selected }),
        });

        if (!addResponse.ok) throw new Error('No se pudo agregar el producto al carrito.');

        await window.BenisCart.updateAttributes({
          Canal: 'Evento QR',
          Evento: eventTag,
        });

        window.location.href = '/checkout';
      } catch (err) {
        console.error('Event buy checkout error:', err);
        showError('No pudimos iniciar tu compra. Intenta de nuevo.');
        checkoutBtn.textContent = original;
        checkoutBtn.disabled = false;
      }
    });

    updateTotal();
  }

  // Galería de fotos del evento (sections/event-buy.liquid, metacampo
  // custom.galeria_de_fotos). Scroll nativo con scroll-snap: el dedo desliza
  // solo; aquí se suman flechas, puntos y avance automático cada 5 s, que se
  // pausa al interactuar (y se retoma tras 8 s quieto), con la pestaña oculta,
  // y no existe si el sistema pide reducir movimiento.
  function initEventGallery() {
    const gallery = document.querySelector('[data-event-gallery]');
    if (!gallery) return;

    const track = gallery.querySelector('[data-event-gallery-track]');
    const slides = [...track.children];
    const dots = [...gallery.querySelectorAll('[data-event-gallery-dot]')];
    if (slides.length < 2) return;

    const interval = Number(gallery.dataset.interval) || 5000;
    const resumeDelay = 8000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let timer = null;
    let resumeTimer = null;

    function goTo(index) {
      const next = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[next].offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    }

    function setCurrent(index) {
      current = index;
      dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (reducedMotion.matches || document.hidden) return;
      timer = window.setInterval(() => goTo(current + 1), interval);
    }

    function pauseByUser() {
      stop();
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(start, resumeDelay);
    }

    // La foto visible define el punto activo, venga el cambio del dedo,
    // de una flecha o del avance automático.
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setCurrent(slides.indexOf(entry.target));
        });
      },
      { root: track, threshold: 0.6 },
    );
    slides.forEach((slide) => observer.observe(slide));

    gallery.querySelector('[data-event-gallery-prev]')?.addEventListener('click', () => {
      pauseByUser();
      goTo(current - 1);
    });
    gallery.querySelector('[data-event-gallery-next]')?.addEventListener('click', () => {
      pauseByUser();
      goTo(current + 1);
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        pauseByUser();
        goTo(Number(dot.dataset.eventGalleryDot));
      });
    });

    track.addEventListener('pointerdown', pauseByUser, { passive: true });
    track.addEventListener('wheel', pauseByUser, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { pauseByUser(); goTo(current - 1); }
      if (event.key === 'ArrowRight') { pauseByUser(); goTo(current + 1); }
    });
    gallery.addEventListener('mouseenter', stop);
    gallery.addEventListener('mouseleave', start);
    gallery.addEventListener('focusin', stop);
    gallery.addEventListener('focusout', (event) => { if (!gallery.contains(event.relatedTarget)) start(); });
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    reducedMotion.addEventListener?.('change', start);

    start();
  }

  document.addEventListener('DOMContentLoaded', initEventBuy);
  document.addEventListener('DOMContentLoaded', initEventGallery);
})();
